export const SET_LOADING_DATA = '@dailyRoute/SET_LOADING_DATA';
export const SET_LOADING_SEND = '@dailyRoute/SET_LOADING_SEND';

export const SET_LOADING_SELECTS = '@dailyRoute/SET_LOADING_SELECTS';

export const GET_ALL_REQUEST = '@dailyRoute/GET_ALL_REQUEST';
export const GET_ALL_SUCCESS = '@dailyRoute/GET_ALL_SUCCESS';

export const GET_BY_ID_REQUEST = '@dailyRoute/GET_BY_ID_REQUEST';
export const GET_BY_ID_SUCCESS = '@dailyRoute/GET_BY_ID_SUCCESS';

export const SAVE_REQUEST = '@dailyRoute/SAVE_REQUEST';
export const SAVE_SUCCESS = '@dailyRoute/SAVE_SUCCESS';

export const DELETE_ITEM = '@dailyRoute/DELETE_ITEM';
export const EDIT_ITEM = '@dailyRoute/EDIT_ITEM';

export const SEARCH = '@dailyRoute/SEARCH';

export const SET_PAGE = '@dailyRoute/SET_PAGE';
export const SET_ROWS_PER_PAGE = '@dailyRoute/SET_ROWS_PER_PAGE';
export const SET_ORDER = '@dailyRoute/SET_ORDER';
export const SET_ORDERBY = '@dailyRoute/SET_ORDEBY';

export const GET_ALL_SELECTS_REQUEST = '@dailyRoute/GET_ALL_SELECTS_REQUEST';
export const GET_ALL_SELECTS_SUCCESS = '@dailyRoute/GET_ALL_SELECTS_SUCCESS';
